export const GameEvents = {
  COLLECT_COIN: 'COLLECT_COIN',
  COLLECT_FOOD: 'COLLECT_FOOD',
  PICKUP_ITEM: 'PICKUP_ITEM',
  DEAL_DAMAGE: 'DEAL_DAMAGE',
  CHECKPOINT: 'CHECKPOINT',
  DEAD: 'DEAD',
  EXIT_STAGE: 'EXIT',
  SPAWN_PROJECTILE: 'SPAWN_PROJECTILE',
  DESTROYED_OBJECT: 'DESTROYED_OBJECT',
  PLAYER_ATTACK_HIT: 'PLAYER_ATTACK_HIT',
  PLAY_LIVES_EXPIRED: 'PLAY_LIVES_EXPIRED',
};
